import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import Link from "next/link";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors } from "utils/styles";

import { Icon } from "components/Icons";
// ProductSearch

import IconButton from "@components/Reusables/IconButton";
import CourseFilterButton from "./components/CourseFilterButton";
import SearchInputBar from "./components/SearchInputBar";
// import ProductSearch from "./components/ProductSearch";
import Title from "@components/Reusables/Title";

export default function FilterBar(props) {
	const {
		hideAssessment = false,
		withBookmark = false,
		withAssessmentBtn = false,
		withSearch = false,
		withProductSearch = false,
		withBookSearch = false,
		subNavScroll = 0,
		isMiniSiteSubNav = false,
		className = "",
		isSlimNav = false,
		withScroll = false,
		navIgnore = "",
		filterButtons = [],
	} = props;
	let ProductSearch = <></>;
	let BookSearch = <></>;
	if (withProductSearch) {
		ProductSearch = dynamic(() => import("./components/ProductSearch"), { ssr: false });
	}

	let bookSearch = <></>;
	if (withBookSearch) {
		BookSearch = dynamic(() => import("./components/BookSearch"), { ssr: false });
	}
	const [showSearch, setShowSearch] = useState(false);

	return (
		<Container fluid className={`g-0 py-3 container-lg px-lg-0 px-2 px-sm-5 position-relative ${className}`}>
			<Row className={`d-flex align-items-top `}>
				{showSearch && <SearchInputBar setShowSearch={setShowSearch} />}
				{/* {!showSearch && ( */}
				<Row className={showSearch ? `invisible` : ""}>
					{filterButtons.title && isSlimNav && (
						<Col className="ps-5" md={"12"}>
							<Title text={filterButtons.title} element="h4" />
						</Col>
					)}

					{withBookSearch && <BookSearch />}
					{withProductSearch && <ProductSearch />}
					<Col md={"auto"}>
						<div
							onClick={() => {
								if (subNavScroll) {
									window.scrollTo(0, subNavScroll);
								}
							}}
							className="g-0  row d-inline-flex filterButtonsBar"
						>
							{/* Filter buttons */}
							{filterButtons.map((data) => (
								<React.Fragment key={data.name}>
									<CourseFilterButton navIgnore={navIgnore} withScroll={withScroll} data={data} />
								</React.Fragment>
							))}
						</div>
					</Col>

					{!hideAssessment && (
						<Col className=" ">
							{/* Bookmark and assessment buttons */}
							<Row className=" g-0 justify-content-end">
								{/* Bookmarked Icon */}
								{withBookmark && (
									<Col xs="auto">
										<IconButton
											label="My Bookmarks"
											btn1={{ url: withBookmark }}
											icon="bookmark"
											button1Variant="transparent"
										/>
									</Col>
								)}

								{withSearch && (
									<>
										<Col xs="auto">
											<IconButton
												onClick={() => setShowSearch(true)}
												label="Search"
												icon="search"
												button1Variant="transparent"
											/>
										</Col>
									</>
								)}

								{/* Assessment button */}
								{withAssessmentBtn && (
									<Col xs={12} sm={9} className="">
										<div className="ps-sm-4">
											<div className="d-inline-flex align-items-center w-100 assessment-button">
												<div className="d-inline-flex ">
													{/* Color gradient left of button */}
													<Icon icon="colorGradient" size={"lg"} />
												</div>
												<div className="d-inline-flex align-self-stretch w-100  w-100">
													<div className="d-flex flex-column justify-content-center px-3">
														<div className="btn-text">Uncover your personal plan:</div>
														<div className="btn-text">Take the Leadership Assessment</div>
													</div>
												</div>
											</div>
										</div>
									</Col>
								)}
							</Row>
						</Col>
					)}
				</Row>
				{/* )} */}
			</Row>

			<style jsx>{`
				.btn-text {
					color: white;
					font-weight: 600;
				}
				.assessment-button {
					background: ${colors["darkBlue"]};
					border-radius: 10px;
				}
			`}</style>
		</Container>
	);
}
